import { ConfidenceLevel } from "@teaming/common-enums";

export default {
	text: "{changedBy} changed the confidence level of this KR from {previousConfidenceLevel} to {currentConfidenceLevel}.",

	[ `confidence${ ConfidenceLevel.HIGH }` ]: "High",
	[ `confidence${ ConfidenceLevel.MEDIUM }` ]: "Medium",
	[ `confidence${ ConfidenceLevel.LOW }` ]: "Low",
};
